module.exports = __webpack_public_path__ + "static/media/indorse-logo@3x.17af7937.png";